var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"newsletter-type-create"}},[_c('h2',[_vm._v("Create Newsletter Type")]),_vm._v(" "),_c('newsletter-type-nav'),_vm._v(" "),(_vm.digest)?_c('newsletter-type-digest-generator'):_vm._e(),_vm._v(" "),_c('newsletter-type-form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d955e00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterTypeCreate.vue
// module id = 1199
// module chunks = 1